<template>
  <div class="main-content clearfix">
    <div class="row">
      <div class="col-xs-12 table-filter">
        <div class="row p-b-sm">
          <div class="col-xs-12">
            <h4 class="table-name">组织结构</h4>
            <div class="b-b"></div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-sm-6 col-xs-12">
            <div class="row org-tree">
              <div class="col-xs-12">
                <tree-view :model="orgs" @add="add" @del="del" @update="update" @qrcode="qrcode" func="1,2,3,5"></tree-view>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xs-12">
            <div class="panel">
              <div class="panel-title bg-primary color-white">
                新增\修改组织信息
              </div>
              <div class="panel-body">
                <form id="orgazination-edit-form">
                  <div class="form-group">
                    <div class="label">组织名称</div>
                    <div class="m-t-xs">
                      <input type="text" v-model="org.name" class="input input-md" placeholder="请输入组织名称" required>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="label">排序</div>
                    <div class="m-t-xs">
                      <input type="number" v-model="org.sort" value="0" class="input input-md" placeholder="排序序号" min="0" step="1" required>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="label">上级组织</div>
                    <div class="m-t-xs clearfix" v-for="(parent,indexd) in org.pids" :key="indexd">
                      <select v-model="parent.selected" class="select input-md col-xs-12" @change="selectParent($event,indexd)">
                        <option :value="p._id" v-for="p in parent.options" :key="p._id">{{p.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="actions text-center">
                    <button type="button" class="btn btn-sm btn-default m-r-lg" @click="clear">取消</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="upsert" :disabled="is_processing === 1">保存</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- import -->
    <div v-if="modal.show">
      <div class="overlay"></div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close" @click="close()">X</span>
          </div>
          <div class="modal-body" style="min-height:300px; width:400px;">
            <div class="row">
              <div class="col-xs-12">
                <img :src="modal.img" alt="" width="360" height="360">
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- import  end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { deepCopy } from "../../plugins/utils";
import Organization from "../../resource/organization";
import Toast from "../../plugins/toaster";
import TreeView from "../blocks/tree";
import QRCode from "qrcode";
export default {
  data: function() {
    return {
      orgs: [],
      view_orgs: {},
      org: {
        _id: "",
        name: "",
        sort: 1,
        pid: "",
        pids: [
          {
            selected: "-1",
            options: [{ _id: "-1", name: "请选择..." }]
          }
        ]
      },
      is_processing: -1,
      modal: {
        show: false,
        title: "二维码",
        img: "src"
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  components: {
    TreeView
  },
  created: function() {
    const that = this;
    if (that.user.category === 2) {
      document.title = `组织结构-企业控制台|${that.global.name}`;
      that.load();
    } else {
      that.$router.replace("/");
    }
  },
  watch: {},
  methods: {
    load: function() {
      let that = this;
      Organization.query({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            let orgs = data.result || [];
            let _orgs = [];
            that.view_orgs = {};
            orgs.forEach(org => {
              // 自身检查
              let tmp = that.view_orgs[org._id];
              if (!tmp) {
                // 不存在
                tmp = org;
                tmp.children = [];
                tmp.is_opened = -1;
                tmp.is_locked = -1;
                that.view_orgs[org._id] = tmp; // 设置
              } else {
                // 存在
                tmp.name = org.name;
                tmp.pid = org.pid;
                tmp.sort = org.sort;
              }
              if (tmp.pid) {
                //父级检查
                let p = that.view_orgs[tmp.pid];
                if (!p) {
                  // 不存在
                  p = {
                    _id: org.pid,
                    children: [],
                    is_opened: 1,
                    is_locked: -1
                  };
                  that.view_orgs[org.pid] = p; // 设置
                }
                p.children.push(tmp);
              } else {
                _orgs.push(tmp);
              }
            });
            let sort = function(ogs) {
              ogs.sort((a, b) => {
                return a.sort - b.sort;
              });
              ogs.forEach(og => sort(og.children));
            };
            sort(_orgs);
            that.orgs = _orgs;
            that.clear();
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    clear: function() {
      const that = this;
      that.org._id = "";
      that.org.name = "";
      that.org.sort = that.orgs.length;
      that.org.pid = -1;
      that.org.pids = [
        {
          selected: "-1",
          options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
        }
      ];
    },
    add: function(p) {
      const that = this;
      that.clear();
      that.org.sort = p.children.length;
      let pids = [];
      let recursion = function(_id, pid) {
        // 向前追溯
        if (!pid) {
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
          });
        } else {
          let p1 = that.view_orgs[pid]; // 父级
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(p1.children)
          });
          recursion(p1._id, p1.pid);
        }
      };
      if (p.pid) {
        recursion(p._id, p.pid);
      } else {
        pids.push({
          selected: p._id,
          options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
        });
      }
      if (p.children && p.children.length > 0) {
        pids.push({
          selected: "-1",
          options: [{ _id: "-1", name: "请选择..." }].concat(p.children)
        });
      }
      that.org.pids = pids;
    },
    update: function(p) {
      const that = this;
      that.org._id = p._id;
      that.org.name = p.name;
      that.org.sort = p.sort;
      let pids = [];
      let recursion = function(_id, pid) {
        // 向前追溯
        if (!pid) {
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
          });
        } else {
          let p1 = that.view_orgs[pid]; // 父级
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(p1.children)
          });
          recursion(p1._id, p1.pid);
        }
      };
      if (p.pid) {
        recursion(p._id, p.pid);
        pids[pids.length - 1].selected = "-1";
      } else {
        pids.push({
          selected: "-1",
          options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
        });
      }
      let last = pids[pids.length - 1];
      for (let i = 0; i < last.options.length; i++) {
        let t = last.options[i];
        if (t._id === p._id) {
          last.options.splice(i, 1);
          break;
        }
      }
      that.org.pids = pids;
    },
    del: function(p) {
      const that = this;
      p.is_locked = 1;
      if (p.children && p.children.length > 0) {
        alert(
          `组织“${
            p.name
          }”下，存在子部门，不能删除！\n请移除所有子部门后，再进行删除操作。`
        );
      } else {
        if (confirm(`您确定要删除组织“${p.name}”吗？删除后不可恢复！！！`)) {
          Organization.delete({ _id: p._id }).then(
            res => {
              // 保存组织结构
              let data = res.body;
              if (data.code === 0) {
                Toast.alert("删除成功");
                that.migrateOrg(p, 2);
              } else {
                Toast.alert(data.msg);
              }
            },
            res => {
              p.is_locked = -1;
            }
          );
        } else {
          p.is_locked = -1;
        }
      }
    },
    selectParent: function(event, indexd) {
      const that = this;
      let val = event.target.value;
      that.org.pids = that.org.pids.slice(0, indexd + 1);
      if (val !== "-1") {
        // indexd
        let tmp = that.view_orgs[val];
        if (tmp) {
          if (tmp.children.length > 0) {
            that.org.pids.push({
              selected: "-1",
              options: [{ _id: "-1", name: "请选择..." }].concat(tmp.children)
            });
            if (that.org._id) {
              let last = that.org.pids[that.org.pids.length - 1];
              for (let i = 0; i < last.options.length; i++) {
                let t = last.options[i];
                if (t._id === that.org._id) {
                  last.options.splice(i, 1);
                  break;
                }
              }
            }
          }
        }
      }
    },
    upsert: function() {
      const that = this;
      let org = {
        pid: "",
        name: that.org.name,
        sort: that.org.sort
      };
      that.org.pids.forEach(p => {
        // 设置父级数据
        if (p.selected !== "-1") {
          org.pid = p.selected;
        }
      });
      if (!org.pid) {
        // 移除pid
        delete org.pid;
      }
      if (that.org._id) {
        org._id = that.org._id;
        Organization.update({ _id: org._id }, org).then(
          res => {
            // 保存组织结构
            let data = res.body;
            if (data.code === 0) {
              Toast.alert("修改成功");
              that.clear();
              that.migrateOrg(org, 3);
            } else {
              Toast.alert(data.msg);
            }
          },
          res => {}
        );
      } else {
        // 新增
        Organization.save({}, org).then(
          res => {
            // 保存组织结构
            let data = res.body;
            if (data.code === 0) {
              Toast.alert("保存成功");
              that.clear();
              that.migrateOrg(data.result, 1);
            } else {
              Toast.alert(data.msg);
            }
          },
          res => {}
        );
      }
    },
    migrateOrg: function(org, action) {
      const that = this;
      if (action === 1) {
        // 新增
        org.is_opened = 1;
        org.is_locked = -1;
        org.children = [];
        if (org.pid) {
          // 非顶级
          let p = that.view_orgs[org.pid];
          if (p) {
            p.children.push(org);
          }
        } else {
          that.orgs.push(org);
        }
        that.view_orgs[org._id] = org;
      } else if (action === 2) {
        // 删除
        if (org.pid) {
          // 非顶级
          let p = that.view_orgs[org.pid];
          if (p) {
            let index = p.children.findIndex(o => {
              return o._id == org._id;
            });
            if (index >= 0) {
              p.children.splice(index, 1);
            }
          } else {
            let index = that.orgs.findIndex(o => {
              return o._id == org._id;
            });
            if (index >= 0) {
              that.orgs.splice(index, 1);
            }
          }
        }
        delete that.view_orgs[org._id];
      } else if (action === 3) {
        let o = that.view_orgs[org._id];
        o.name = org.name;
        o.sort = org.sort;
        if (o.pid) {
          // 存在pid
          if (o.pid != org.pid) {
            // 不同处理一下
            if (org.pid) {
              // 新的pid 也存在
              let p1 = that.view_orgs[o.pid];
              let p2 = that.view_orgs[org.pid];
              if (p1) {
                // 移除数据
                let index = p1.children.findIndex(c => {
                  return c._id == o._id;
                });
                if (index >= 0) {
                  p1.children.splice(index, 1);
                }
              }
              if (p2) {
                // 移入数据
                p2.children.push(o);
              }
              o.pid = org.pid;
            } else {
              // 不存在，移除
              let p1 = that.view_orgs[o.pid];
              if (p1) {
                // 移除数据
                let index = p1.children.findIndex(c => {
                  return c._id == o._id;
                });
                if (index >= 0) {
                  p1.children.splice(index, 1);
                }
              }
              that.orgs.push(o); // 加入顶级
              o.pid = ""; // 清除父级数据
            }
          }
        } else {
          // 不存在
          if (org.pid) {
            // 存在新增
            let index = that.orgs.findIndex(c => {
              return c._id == o._id;
            });
            if (index >= 0) {
              that.orgs.splice(index, 1);
            }
            let p2 = that.view_orgs[org.pid];
            if (p2) {
              // 移入数据
              p2.children.push(o);
            }
            o.pid = org.pid;
          }
        }
      }
      let sort = function(ogs) {
        ogs.sort((a, b) => {
          return a.sort - b.sort;
        });
        ogs.forEach(og => sort(og.children));
      };
      sort(that.orgs);
    },
    qrcode: function(org) {
      const that = this;
      const win = window;
      const loc = win.location;
      QRCode.toDataURL(
        `${loc.protocol}//${loc.host}/web/v1/auth/register-with-group/${
          org._id
        }`,
        { width: 470, height: 470 },
        function(err, url) {
          if (err) {
          } else {
            that.modal.img = url;
            that.modal.title = `查看二维码：${org.name}`;
            that.modal.show = true;
          }
        }
      );
    },
    close: function() {
      const that = this;
      that.modal.show = false;
    }
  }
};
</script>
<style lang="less" scoped>
.invitate-code {
  padding-left: 15px;
  padding-right: 15px;
  &.code_is_active {
    color: #42b983;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.select-invitation-list {
  border: 1px solid #e8e8e8;
  background-color: #eee;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// organization.vue?7b5771c3